export default __webpack_public_path__ + "static/media/nft3.15d1d81a.png";